import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { onRateLimit } from '@config/api';

// Evita empilhar vários toasts quando muitas requisições tomam 429 ao mesmo
// tempo (ex.: vários F5 seguidos disparando dezenas de chamadas paralelas).
const THROTTLE_MS = 5000;

/**
 * Exibe um toast global de "muitas requisições" sempre que o backend responde
 * 429, independente da rota. Mantém o usuário onde está em vez de derrubá-lo.
 */
export function RateLimitToaster() {
  const { toast } = useToast();
  const { t } = useTranslation('common');
  const lastShownRef = useRef(0);

  useEffect(() => {
    return onRateLimit(() => {
      const now = Date.now();
      if (now - lastShownRef.current < THROTTLE_MS) return;
      lastShownRef.current = now;
      toast.danger({
        title: t('rateLimit.title'),
        description: t('rateLimit.message'),
      });
    });
  }, [toast, t]);

  return null;
}
